import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const RegexPassword = new RegExp(`^(?=.*\\d)(?=.*[A-Za-z])(?=.*[a-zA-Z]).*$`);

export function ValidatorPassword(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control?.value ?? '';
    if (!value || value === '') return null;

    const tested = new RegExp(RegexPassword, 'gm').test(value);
    const length = (value.length ?? 0) >= 8;
    return !tested
      ? { passwordChars: { value: control.value } }
      : !length
        ? { passwordLength: { value: control.value } }
        : null;
  };
}
